import { CardMedia, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { helpHttp } from "../../helper/helpHttp";
import * as Styled from "./ExperienciaFleischmann.styled";
import { useDispatch, useSelector } from "react-redux";
import { changeLoading } from "../../redux/slices/category";
import { BuildingPage } from "../../components/BuildingPage/BuildingPage";

export const ExperienciaFleischmann = () => {
  const [data, setData] = useState(undefined);
  const { get } = helpHttp();
  const dispatch = useDispatch();
  const { previewModeEnabled } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(changeLoading(true));

    get(`categorias/getSubcategorias/10`)
      .then((data) => {
        setData(data.datos);
      })
      .catch(() => toast.error("Ha ocurrido un error"))
      .finally(() => {
        dispatch(changeLoading(false));
      });
  }, []);

  if (!previewModeEnabled) {
    return <BuildingPage />;
  }

  return (
    <Styled.GridData>
      {data?.length > 0 &&
        data.map((element) => (
          <Link to={`${element.id}`}>
            <Styled.StyledCard
              estado={element.estado}
              key={element.id}
              image={element.icon || "/images/auth__bread.jpg"}
            >
              {/* <CardMedia
                component="img"
                image={element.icon || "/images/auth__bread.jpg"}
                alt={element.nombre}
              /> */}
              {/* <Styled.StyledCardContent>
                <Typography gutterBottom variant="subtitle" fontWeight={700}>
                  {element.nombre}
                </Typography>
              </Styled.StyledCardContent> */}
            </Styled.StyledCard>
          </Link>
        ))}
    </Styled.GridData>
  );
};
